module.exports = __webpack_public_path__ + "img/Z60Q_07.9453696a.jpg";